// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyLayoutUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var GridLayoutUIStore = require('share/components/controls/GridLayout/Izenda.GridLayoutUIStore');
  var GridItemState = require('share/components/controls/GridLayout/Izenda.GridItemState');
  var CONSTANTS = require('logic/data/Izenda.ReportBodyConstants');
  var MIN_PART_WIDTH = 3;
  var MIN_PART_HEIGHT = 3;
  var { create } = require('lodash/fp');

  function ReportBodyLayoutUIStore (width, fullSize, infinityRows, infinityCols){
    GridLayoutUIStore.call(
      this,
      CONSTANTS.BODY_CELL_WIDTH,    // default grid cell width
      CONSTANTS.BODY_CELL_HEIGHT,   // default grid cell height
      width,                        // report body width
      CONSTANTS.NUMBER_BODY_ROWS,   // report body layout rows
      CONSTANTS.NUMBER_BODY_COLS,   // report body layout cols
      infinityRows,                 // allow infinity rows
      infinityCols,                 // allow infinity cols
      fullSize,                     // view in full size mode
      true,
      MIN_PART_WIDTH,
      MIN_PART_HEIGHT
    );
  }

  ReportBodyLayoutUIStore.prototype =  create(GridLayoutUIStore.prototype, {
    'constructor': ReportBodyLayoutUIStore
  });

  module.exports = ReportBodyLayoutUIStore;
}();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.ReportBodyLayoutUIStore.js